module.exports = __webpack_public_path__ + "static/dietopro-app.54e75b37.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cases/detail/dietopro-app.png
// module id = 588
// module chunks = 101035529556142